import { useCallback, useMemo, useState } from 'react';

export const usePDFViewerPresenter = () => {
  const [page, setPage] = useState(1);
  const [numPages, setNumPages] = useState(null);

  const onDocumentLoadSuccess = useCallback(({ numPages }) => {
    setNumPages(numPages);
  }, []);

  const showLeftControl = useMemo(() => {
    return page > 1;
  }, [page]);

  const showRightControl = useMemo(() => {
    return page + 1 <= numPages;
  }, [page, numPages]);

  return {
    page,
    numPages,
    showLeftControl,
    showRightControl,
    setPage,
    onDocumentLoadSuccess,
  };
};
